import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import {createPinia} from 'pinia'
// import Print from "vue-print-nb";

//import VueSlideoutPanel from "vue2-slideout-panel";

// import "../templates/wireframe.scss";

// import infiniteScroll from "vue3-infinite-scroll-good";
// import ConfirmationService from 'primevue/confirmationservice';
// import ConfirmDialog from 'primevue/confirmdialog';

// import PrimeVue from 'primevue/config';
// import Chart from 'primevue/chart';
// import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import { VueReCaptcha } from 'vue-recaptcha-v3';

// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap';
// import '@popperjs/core';

const pinia = createPinia()

// const stripeOptions = {
//   pk: process.env.STRIPE_PUBLISHABLE_KEY
//   //   stripeAccount: process.env.STRIPE_ACCOUNT,
//   //   apiVersion: process.env.API_VERSION,
//   //   locale: process.env.LOCALE,
// };

//import Vuex from "vuex";
//import Vueditor from "vueditor";
//import "vueditor/dist/style/vueditor.min.css";

// import VueSimpleAlert from "vue3-simple-alert";
import VueNumberFormat from 'vue-number-format';
// import FloatingVue from 'floating-vue'
// const createApp = require("vue");
// const App = require("./App.vue");
// const router = require("./router");
// import 'floating-vue/dist/style.css'


const app = createApp(App);

// console.log(process.env.VUE_APP_CAPTCHA_SITE_KEY)

// window.onerror = function (message, source, line, column, error) {
//   // console.log('LORD OF THE LOGS::>>>', error);
// };

console.warn = () => {};

app.config.productionTip = false;
app.config.warnHandler = () => {};

app
  .use(router)
  .use(pinia)
  // .use(Print)
  // .use(ConfirmationService)
  .use(VueNumberFormat, {prefix: 'US$ ', decimal: '.', thousand: ','})
  .use(VueReCaptcha, {
    // v2SiteKey: '6LfH1jclAAAAALNAZRQ9oLVW-B_SRyfWJj1bZZfu',
    siteKey: process.env.VUE_APP_CAPTCHA_SITE_KEY
  })
  // .use(FloatingVue)
  // .use(PrimeVue, {
  //   zIndex: {
  //       modal: 1100,        //dialog, sidebar
  //       overlay: 1000,      //dropdown, overlaypanel
  //       menu: 1000,         //overlay menus
  //       tooltip: 1100       //tooltip
  //     }
  // })

  //.use(VueSlideoutPanel)
  //.use(infiniteScroll)
  .mount('#app');


//app.use(VueColumnsResizable);
